import { render, staticRenderFns } from "./ComparisonChart.vue?vue&type=template&id=547a4d7f&"
import script from "./ComparisonChart.vue?vue&type=script&lang=js&"
export * from "./ComparisonChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports